/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

const esMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  'user.login-title': 'Iniciar sesión',
  'user.register': 'Registro',
  'user.forgot-password': 'Se te olvidó tu contraseña',
  'user.email': 'Email',
  'user.password': 'Contraseña',
  'user.forgot-password-question': '¿Contraseña olvidada?',
  'user.fullname': 'Nombre completo',
  'user.login-button': 'INICIAR SESIÓN',
  'user.register-button': 'REGISTRO',
  'user.reset-password-button': 'REINICIAR',
  'user.buy': 'COMPRAR',
  'user.username': 'Nombre de Usuario',

  /* 03.Menú */
  'menu.online': 'En línea',
  'menu.offline': 'Desconectado',
  'menu.app': 'Inicio',
  'menu.default': 'Defecto',
  'menu.analytics': 'Analítica',
  'menu.ecommerce': 'Comercio electrónico',
  'menu.content': 'Contenido',
  'menu.pages': 'Páginas',
  'menu.data-list': 'Lista Datos',
  'menu.thumb-list': 'Lista Pulgares',
  'menu.image-list': 'Lista Imagen',
  'menu.details': 'Detalles',
  'menu.search': 'Búsqueda',
  'menu.login': 'Iniciar sesión',
  'menu.register': 'Registro',
  'menu.forgot-password': 'Olvidé mi contraseña',
  'menu.error': 'Error',
  'menu.applications': 'Aplicaciones',
  'menu.todo': 'Notas',
  'menu.survey': 'Encuesta',
  'menu.chat': 'Chatea',
  'menu.ui': 'IU',
  'menu.alerts': 'Alertas',
  'menu.badges': 'Badges',
  'menu.buttons': 'Botones',
  'menu.cards': 'Tarjetas',
  'menu.carousel': 'Carrusel',
  'menu.charts': 'Gráficos',
  'menu.collapse': 'Colapso',
  'menu.dropdowns': 'Menús Desplegables',
  'menu.editors': 'Editores',
  'menu.form-layouts': 'Diseños de Formulario',
  'menu.form-components': 'Componentes de Formulario',
  'menu.form-validations': 'Validaciones de Formulario',
  'menu.icons': 'Iconos',
  'menu.input-groups': 'Grupos de Entrada',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navegación',
  'menu.popover-tooltip': 'Tooltips y Popovers',
  'menu.sortable': 'Ordenable',
  'menu.tables': 'Tablas',
  'menu.menu': 'Menú',
  'menu.subhidden': 'Sub Oculto',
  'menu.hidden': 'Oculto',
  'menu.visible': 'Visible',
  'menu.maps': 'Mapas',

  'menu.landingpage': 'Página de Destino',
  'menu.multipage-home': 'Múltiple Página',
  'menu.singlepage-home': 'Una Página',
  'menu.about': 'Acerca de',
  'menu.auth-login': 'Autenticación',
  'menu.auth-register': 'Registro',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Detalle del Blog',
  'menu.careers': 'Carrera',
  'menu.confirmation': 'Confirmación',
  'menu.contact': 'Contacto',
  'menu.docs': 'Docs',
  'menu.features': 'Caracteristicas',
  'menu.prices': 'Precios',
  'menu.videos': 'Videos',
  'menu.mailing': 'Correo',
  'menu.invoice': 'Factura',
  'menu.blank-page': 'Blank Page',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.update': 'Actualizar',
  'dashboards.save': 'Ahorrar',
  'dashboards.name': 'Nombre',
  'dashboards.button': 'Botón',
  'dashboards.visits': 'Visitas',
  'dashboards.checkAvailability': 'Consultar disponibilidad o tarifas',
  'dashboards.details': 'Detalles',
  'dashboards.pending-orders': 'Pedidos Pendientes',
  'dashboards.completed-orders': 'Pedidos Completados',
  'dashboards.refund-requests': 'Petición de Reembolso',
  'dashboards.new-comments': 'Nuevos Comentarios',
  'dashboards.sales': 'Ventas',
  'dashboards.orders': 'Pedidos',
  'dashboards.refunds': 'Reembolso',
  'dashboards.recent-orders': 'Pedidos Recientas',
  'dashboards.product-categories': 'Categorías de Producto',
  'dashboards.cakes': 'Tortas',
  'dashboards.tickets': 'Entradas',
  'dashboards.calendar': 'Calendario',
  'dashboards.best-sellers': 'Mejores Vendidos',
  'dashboards.website-visits': 'Visitas al sitio web',
  'dashboards.unique-visitors': 'Visitantes únicos',
  'dashboards.this-week': 'Esta Semana',
  'dashboards.last-week': 'La Semana Pasada',
  'dashboards.this-month': 'Este Mes',
  'dashboards.conversion-rates': 'Medidas de Conversión',
  'dashboards.per-session': 'Por Sección',
  'dashboards.profile-status': 'Estado del Perfil',
  'dashboards.payment-status': 'Estado del Pago',
  'dashboards.work-progress': 'Trabajo en Progreso',
  'dashboards.tasks-completed': 'Tareas Completadas',
  'dashboards.payments-done': 'Pagos Realizados',
  'dashboards.order-stock': 'Pedidos - Valores',
  'dashboards.categories': 'Categorías',
  'dashboards.quick-post': 'Publicación Rápida',
  'dashboards.title': 'Título',
  'dashboards.content': 'Contenido',
  'dashboards.ticket-count': 'Recuento de entradas',
  'dashboards.commonticketsubmission': 'Envíos comunes de boletos',
  'dashboards.category': 'Categoría',
  'dashboards.connect': 'Conectar',
  'dashboards.save-and-publish': 'Guardar y Publicar',
  'dashboards.top-viewed-posts': 'Publicaciones Más Vistas',
  'dashboards.posts': 'Puestos',
  'dashboards.pending-for-publish': 'Pendiente de Publicación',
  'dashboards.users': 'Usuarios',
  'dashboards.on-approval-process': 'En Proceso de Aprobación',
  'dashboards.alerts': 'Alertas',
  'dashboards.waiting-for-notice': 'Esperando Aviso',
  'dashboards.files': 'Archivos',
  'dashboards.pending-for-print': 'Pendiente para imprimir',
  'dashboards.logs': 'Troncos',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MAGIA ESTA EN LOS DETALLES',
  'dashboards.yes-it-is-indeed': '¡Si es verdad!',
  'dashboards.advanced-search': 'Búsqueda Avanzada',
  'dashboards.toppings': 'Coberturas',
  'dashboards.type': 'Categoría',
  'dashboards.keyword': 'Palabra Clave',
  'dashboards.search': 'Búsqueda',
  'dashboards.top-rated-items': 'Artículos Mejores Valorados',
  'dashboards.country': 'País',
  'dashboards.webVisitors': 'Visitantes web',
  'dashboards.avatarClicks': 'Clics de avatar',
  'dashboards.wordCloud': 'Nube de palabras',
  'dashboards.topic': 'Tema',
  'dashboards.roomsAvailability': 'Habitaciones y disponibilidad',
  'dashboards.startChat': 'Iniciar un chat',
  'dashboards.restaurantsBars': 'Restaurantes y bares',
  'dashboards.groupBooking': 'Reserva de grupo',
  'dashboards.promotions': 'Promociones',
  'dashboards.weedingevents': 'Bodas y Eventos',
  'dashboards.lostsomething': 'Perder algo',
  'dashboards.producttext': 'Texto de producto',
  'dashboards.bookingroomnew': 'Reservar habitación nueva',
  'dashboards.email': 'Correo electrónico',
  'dashboards.phone': 'Teléfono',
  'dashboards.zipcode': 'Código postal',
  'dashboards.marketingconsent': 'Consentimiento de comercialización',
  'dashboards.additionalinfo': 'Información adicional',
  'dashboards.viewallcontacts': 'Ver todos los contactos',
  'dashboards.current': 'Actual',
  'dashboards.last7days': 'Últimos 7 días',
  'dashboards.last30days': 'Últimos 30 días',
  'dashboards.thisweek': 'Esta semana',
  'dashboards.thismonth': 'Este mes',
  'dashboards.previousmonth': 'Mes anterior',
  'dashboards.yeartodate': ' El año hasta la fecha',
  'dashboards.lastyear': 'El año pasado',
  'dashboards.all': 'Todos',
  'dashboards.standardOccupancy': 'Ocupación estándar',
  'dashboards.max-occupancy': 'Ocupación máxima',
  'dashboards.numberOfThisType': 'Número de este tipo',
  'dashboards.displayOrder': 'Orden de visualización ',
  'dashboards.provider': 'Proveedor',
  'dashboards.edit': 'Editar',
  'dashboards.delete': 'Borrar',
  'dashboards.addImages': 'Agregar imágenes',
  'dashboards.location_ip': 'Sijainti on likimääräinen ja määritetty IP‑osoitteen perusteella',
  'dashboards.near': 'Cerca',
  'dashboards.referral': 'Käyttäjä ohjasi sivullesi tämän verkkosivuston kautta',
  'dashboards.calling_party': 'Soittava osapuoli',
  'dashboards.called_party': 'Vastaanottava osapuoli',
  'dashboards.lastdial': 'Viimeksi valittu',
  'dashboards.imagelink': 'Kuvalinkki',
  'dashboards.browsegallery': 'Selaa galleriaa',
  'dashboards.changelog': 'Registro de cambios',
  'dashboards.externalresources': 'Recursos externos ',
  'dashboards.webpage': 'Página web',
  'dashboards.web-pages': 'Páginas web',
  'dashboards.published': 'Publicado ',
  'dashboards.adddocument': 'Agregar documento',
  'dashboards.ready-to-publish': 'Listo para publicar',
  'dashboards.draft': 'Borrador',
  'dashboards.order-by': 'Ordenar por',
  'dashboards.add-faq': 'Agregar preguntas frecuentes ',
  'dashboards.collections': 'Colecciones',
  'dashboards.items': 'Elementos',
  'dashboards.rooms-availability': 'Habitaciones y disponibilidad',
  'dashboards.events-wedding-venues': ' Lugares para eventos y bodas',
  'dashboards.long-stay-enquiry': 'Consulta de estancias prolongadas',
  'dashboards.reservation-confirmation-request': 'Solicitud de confirmación de reserva',
  'dashboards.modify-cancel-booking': 'Modificar o cancelar reserva',
  'dashboards.left-something-behind': 'Dejó algo atrás',
  'dashboards.invoice-copy': 'Copia de factura / recibo',
  'dashboards.sync': 'Sincronizar',
  'dashboards.add-web-page': 'Agregar página web',
  'dashboards.sprint-title': 'Descubre Sprint, nuestra innovadora automatización para entrenar el modelo de IA en 10 veces menos tiempo.',
  'dashboards.sprint-description': 'Sprint trabaja contigo para impulsar tu creatividad, impulsar tu productividad y reducir drásticamente el tiempo de entrenamiento del Asistente Digital.',
  'dashboards.sprint-feature': 'La función Sprint está diseñada para sincronizar conocimientos desde fuentes externas, lo que la hace valiosa tanto para la configuración inicial como para actualizaciones continuas de datos. Cuando se ejecuta en un sistema activo, Sprint modifica el Centro de Conocimiento según tus fuentes externas configuradas, lo que puede influir directamente en los comportamientos y respuestas generadas por IA. Para obtener asistencia con la configuración de Sprint, por favor contacta con nuestro equipo de soporte.',
  'dashboards.change-password': ' Cambiar la contraseña',
  'dashboards.sign-out': 'Desconectar',
  'dashboards.privacy-policy': 'Política de privacidad',
  'dashboards.help-center': 'Centro de ayuda',
  'dashboards.switch-account': 'Cambiar de cuenta',
  'dashboards.business-settings': 'Configuración empresarial',
  'dashboards.notifications-allowed': 'Notificaciones permitidas',
  'dashboards.dark-theme': 'Tema oscuro',
  'dashboards.online': 'En línea',
  'dashboards.offline': 'Sin conexión',
  'dashboards.invoice-&-payments': 'Facturas y pagos',
  'dashboards.upgrade-plan': 'Actualizar plan',
  'dashboards.add-room': 'Añadir habitación',
  'dashboards.room-type': 'Tipo de habitación',
  'dashboards.room-name': 'Nombre de la habitación',
  'dashboards.how-many-guests': '¿Cuántos huéspedes pueden alojarse en esta habitación?',
  'dashboards.number-of-rooms-this-type': 'Número de habitaciones (de este tipo)',
  'dashboards.number-of-bedrooms': 'Número de dormitorios',
  'dashboards.number-of-livingrooms': 'Número de salones',
  'dashboards.minimum-adults': 'Adultos mínimos',
  'dashboards.maximum-adults': 'Adultos máximos',
  'dashboards.maximum-children': 'Niños máximos',
  'dashboards.maximum-infants': 'Bebés máximos',
  'dashboards.extra-beds-allowed': 'Camas extra permitidas',
  'dashboards.booking-engine-code': 'Código del motor de reservas',
  'dashboards.room-size': 'Tamaño de la habitación',
  'dashboards.balcony-area': 'Área del balcón',
  'dashboards.unit': 'Unidad',
  'dashboard.whatsapp_message': 'Escribe tu mensaje aquí...',
  'dashboard.whatsapp_reply_window': 'Tienes una ventana de 24 horas para responder a un mensaje de un cliente en WhatsApp Business desde el momento en que el cliente envió su último mensaje. Si respondes dentro de esta ventana de atención al cliente de 24 horas, puedes enviar cualquier tipo de mensaje. Después de que se cierre la ventana de 24 horas, solo podrás enviar mensajes utilizando plantillas de mensajes preaprobadas, que reinician la ventana de 24 horas cuando el cliente responde.',
  'dashboards.square-meters': 'Metros cuadrados',
  "dashboard.pick_quick_reply": "Elige una respuesta rápida o escribe tu mensaje",
  "dashboard.hang_in_there": "Espera mientras intentamos conectarte",
  "dashboard.outbound_msg": "Cuándo enviar el mensaje saliente",
  "dashboard.message_sent": "¡Tu mensaje se ha enviado correctamente!",
  "dashboard.failed_msg": "Error al enviar el mensaje",
  "dashboard.new_chat_message": "Nuevo mensaje de chat",
  "dashboard.user_msg": "Hay un mensaje del usuario en las últimas 24 horas. Puedes enviar cualquier mensaje como respuesta. ¿Deseas enviar este mensaje de plantilla o responder con otro mensaje?",
  "dashboard.us_number": "Los mensajes de WhatsApp Business no se envían a números de EE. UU. porque Meta pausó todos los mensajes de marketing a números de EE. UU. el 1 de abril de 2025.",
  "dashboard.error_msg": "Por favor, complete todos los marcadores de posición correctamente.",

  'web-widget.title': 'Menús de widgets web para el chatbot del sitio web',
  /*Home page*/
  'dashboards.quickstartwithai': 'Inicio rápido con IA',
  'dashboards.fastestpathtoautomation': 'Estás en el camino más rápido hacia la automatización con herramientas de IA',
  'dashboards.insightsthatempower': 'Información que empodera',
  'dashboards.trainchatbot': 'Entrenar chatbot',
  'dashboards.automatewithforms': 'Automatiza con formularios',
  'dashboards.inroomdigitalcompendium': 'Compendio digital en la habitación',
  'dashboards.support': 'Soporte',
  'dashboards.helpcenter': 'Centro de ayuda',
  'dashboards.searchfaqintegrations': 'Busca artículos sobre preguntas frecuentes comunes, integraciones y más.',
  'dashboards.asklivechat': 'Haz una pregunta a nuestro equipo en el chat en vivo',
  'dashboards.inroomqrcode': 'Código QR en la habitación para ver información sobre la propiedad y la ubicación',
  'dashboards.customizewebwidget': 'Personaliza y añade Widget web a tu sitio con un chatbot IA integrado',
  'dashboards.createcustomforms': 'Crea formularios personalizados y recibe notificaciones cuando un huésped envía un formulario',
  'dashboards.trainchatbotproperty': 'Entrena el chatbot con información de tu propiedad como hora de check‑in, actividades, etc.',
  'dashboards.chatbotinsights': 'Descubre cómo tu chatbot interactúa con los huéspedes y obtén estadísticas como visitantes del sitio web, preguntas frecuentes y mucho más.',
  'dashboards.addaichatbottoyourwebsite': 'Agregar Chatbot de IA a tu sitio web',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Resúmenes de conversaciones',
  'dashboards.thread-summary-subtitle': 'Resúmenes de correo electrónico generados por IA',
  'dashboards.ai-replies-title': 'Respuestas de IA',
  'dashboards.ai-replies-subtitle': 'Respuestas generadas por IA',

  'dashboards.total-thread-summary-title': 'Total de resúmenes generados',
  'dashboards.total-ai-replies-title': 'Total de respuestas de IA generadas',
  'dashboards.total-draft-copied': 'Borradores copiados por los usuarios',

  'dashboards.urgency': 'Urgencia',
  'dashboards.sentiment': 'Sentimiento',

  'dashboards.common-email-reasons': 'Motivos comunes de correo electrónico',
  'dashboards.topics-in-emails': 'Temas en los correos electrónicos',

  'dashboards.email-assistant-usage': 'Uso del asistente de correo IA',
  'dashboards.usage-by-email-address': 'Uso por direcciones de correo',

  /* 05.Esquemas */

  'pages.title.dashboards.analytics': 'Análisis',
  'pages.title.ari': 'Disponibilidad y Tarifas',
  'pages.title.conversations': 'Conversaciones',
  'pages.title.bookings': 'Reservas y Reservaciones',
  'pages.title.tickets': 'Leads y Tickets',
  'pages.title.propinfo': 'Respuestas',
  'pages.title.discounts': 'Descuentos y Promociones',
  'pages.title.finance': 'Finanzas',
  'pages.title.integration': 'Integración',
  'pages.title.admin': 'Administración',

  'pages.add-new': 'AGREGAR NUEVO',
  'pages.add-new-modal-title': 'Agregar ítem nuevo',
  'pages.display-options': 'Opciones de Pantalla',
  'pages.orderby': 'Ordenar por : ',
  'pages.product-name': 'Nombre del Producto',
  'pages.category': 'Categoría',
  'pages.description': 'Descripción',
  'pages.status': 'Estado',
  'pages.cancel': 'Cancelar',
  'pages.submit': 'Enviar',
  'pages.delete': 'Borrar',
  'pages.another-action': 'Otra accion',
  'pages.actions': 'ACCIONES',
  'pages.header': 'Encabezado',
  'pages.details': 'DETALLES',
  'pages.orders': 'PEDIDOS',
  'pages.rating': 'Clasificación',
  'pages.price': 'Precio',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Es Vegano',
  'pages.order-status': 'Estado del Pedido',
  'pages.bake-progress': 'Progreso de Hornear',
  'pages.popularity': 'Popularidad',
  'pages.comments': 'Comentarios',
  'pages.error-title': 'Vaya, parece que ha ocurrido un error!',
  'pages.error-code': 'Código de error',
  'pages.go-back-home': 'REGRESAR A INICIO',
  'pages.mailing-info':
    'Las plantillas de correo utilizan el diseño en línea y el diseño de la tabla para mostrarse bien en varios proveedores de servicios. Para proporcionar una mejor usabilidad, lo incluimos como html regular con dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'La plantilla de factura tiene una versión de estilo en línea para uso fuera del proyecto, así como la versión React.',
  'pages.react-version': 'React Versión',
  'pages.inline-version': 'Estilo en Linea Html Versión',

  /* 06.Aplicaciones */

  /* 06.01.Chatea */
  'chat.messages': 'Mensajes',
  'chat.contacts': 'Contactos',
  'chat.saysomething': 'Di algo..',
  /* 06.02.Encuesta */
  'survey.delete': 'Borrar',
  'survey.edit': 'Edit',
  'survey.add-new': 'AGREGAR NUEVO',
  'survey.add-new-title': 'Add New Encuesta',
  'survey.title': 'Título',
  'survey.category': 'Categoría',
  'survey.label': 'Etiqueta',
  'survey.status': 'Estado',
  'survey.cancel': 'Cancelar',
  'survey.submit': 'Enviar',
  'survey.another-action': 'Otra accion',
  'survey.display-options': 'Opciones de Pantalla',
  'survey.orderby': 'Ordenar por : ',
  'survey.all-surveys': 'Todas las Encuestas',
  'survey.completed-surveys': 'Encuestas Completadas',
  'survey.categories': 'Categorías',
  'survey.active-surveys': 'Encuestas Activas',
  'survey.labels': 'Etiquetas',

  /* 06.03.Notas */
  'todo.add-new': 'AGREGAR NUEVO',
  'todo.add-new-title': 'Añadir Nuevo',
  'todo.title': 'Título',
  'todo.detail': 'Detalle',
  'todo.category': 'Categoría',
  'todo.label': 'Etiqueta',
  'todo.status': 'Estado',
  'todo.cancel': 'Cancelar',
  'todo.submit': 'Enviar',
  'todo.action': 'Accion',
  'todo.another-action': 'Otra accion',
  'todo.display-options': 'Opciones de Pantalla',
  'todo.orderby': 'Ordenar por : ',
  'todo.all-tasks': 'Todas las Tareas',
  'todo.pending-tasks': 'Tareas Pendientes',
  'todo.completed-tasks': 'Tareas Completadas',
  'todo.categories': 'Categorías',
  'todo.labels': 'Etiquetas',

  /* 07.IU */

  /* 07.01.Alertas */
  'alert.rounded': 'Alerta Redondeado',
  'alert.react-notifications': 'React Notificaciones',
  'alert.outline': 'Contorno',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Lleno',
  'alert.primary-text': '¡Esto es un primary alert—check fuera!',
  'alert.secondary-text': '¡Esto es un secondary alert—check fuera!',
  'alert.success-text': '¡Esto es un success alert—check fuera!',
  'alert.danger-text': '¡Esto es un danger alert—check fuera!',
  'alert.warning-text': '¡Esto es un warning alert—check fuera!',
  'alert.info-text': '¡Esto es un info alert—check fuera!',
  'alert.light-text': '¡Esto es un light alert—check fuera!',
  'alert.dark-text': '¡Esto es un dark alert—check fuera!',
  'alert.default': 'Alerta por Defecto',
  'alert.dismissing': 'Despido de Alerta',
  'alert.dismissing-text':
    '¡Santo guacamole! Debes revisar algunos de esos campos a continuación.',
  'alert.dismissing-without-animate-text':
    '¡Estoy alerta y me pueden despedir sin animarme!',

  /* 07.02.Badges */
  'badge.sizes': 'Tamaños',
  'badge.colors': 'Colores',
  'badge.outline': 'Contorno',
  'badge.links': 'Enlaces',
  'badge.counter-badges': 'Mostrador Badges',
  'badge.bootstrap-default': 'Bootstrap Defecto',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Botones */
  'button.default': 'Bootstrap Defecto',
  'button.colors': 'Colores',
  'button.rounded': 'Botones Redondeado',
  'button.outline': 'Contorno',
  'button.states': 'Estados',
  'button.sizes': 'Tamaños',
  'button.button-groups': 'Grupos de Botones',
  'button.large-button': 'Botón Grande',
  'button.small-button': 'Botón Pequeño',
  'button.extra-small-button': 'Botón Extra Pequeño',
  'button.block-button': 'Botón de Bloqueo',
  'button.active': 'Activo',
  'button.disabled': 'Discapacitado',
  'button.basic': 'Básico',
  'button.toolbar': 'Barra de Herramientas',
  'button.nesting': 'Anidando',
  'button.vertical-variation': 'Variación Vertical',
  'button.checkbox-radio-button': 'Checkbox  y Radio Buttons',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.',
  'button.click-here': 'Haga clic aquí',
  'button.states-text-alternate':
    'Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.',
  'button.primary-link': 'Primary Enlace',
  'button.link': 'Enlace',
  'button.primary-button': 'Primary Botón',
  'button.button': 'Botón',
  'button.left': 'Izquierda',
  'button.middle': 'Centro',
  'button.right': 'Derecha',
  'button.dropdown': 'Desplegable',
  'button.dropdown-link': 'Enlace Desplegable',

  /* 07.04.Tarjetas */
  'cards.icon-card': 'Tarjeta de Icono',
  'cards.image-card': 'Tarjeta de Imagen',
  'cards.image-overlay-card': 'Tarjeta de Superposición de Imágenes',
  'cards.image-card-list': 'Lista de Tarjetas de Imagen',
  'cards.tab-card': 'Tarjeta de Tab',
  'cards.user-card': 'Tarjeta de Usuario',

  /* 07.05.Carrusel */
  'carousel.basic': 'Carrusel Básico',
  'carousel.single': 'Carrusel Sólo',
  'carousel.without-controls': 'Carrusel sin Control',

  /* 07.06.Gráficos */
  'charts.line': 'Gráfico de Linea',
  'charts.polar': 'Gráfico de Polar',
  'charts.area': 'Gráfico de Área',
  'charts.scatter': 'Gráfico de Dispersión',
  'charts.bar': 'Gráfico de Barras',
  'charts.radar': 'Gráfico de Radar',
  'charts.pie': 'Gráfico de Circular',
  'charts.doughnut': 'Gráfico de Rosquilla',
  'charts.shadow': 'Sombra',
  'charts.no-shadow': 'Sin Sombra',

  /* 07.07.Colapso */
  'collapse.basic': 'Básico',
  'collapse.toggle': 'Palanca',
  'collapse.accordion': 'Acordeón',
  'collapse.controlled': 'Revisado',
  'collapse.uncontrolled': 'Sin Control',

  /* 07.08.Desplegables */
  'dropdowns.basic': 'Básico',
  'dropdowns.controlled': 'Revisado',
  'dropdowns.uncontrolled': 'Sin Control',
  'dropdowns.dropdown': 'Desplegable',
  'dropdowns.header': 'Encabezado',
  'dropdowns.action': 'Accion',
  'dropdowns.another-action': 'Otra accion',
  'dropdowns.right': 'Derecha',
  'dropdowns.left': 'Izquierda',
  'dropdowns.drop-directions': 'Direcciones de drop',
  'dropdowns.dropright': 'Drop Derecha',
  'dropdowns.dropleft': 'Drop Izquierda',
  'dropdowns.small-button': 'Botón Pequeño',
  'dropdowns.large-button': 'Botón Grande',
  'dropdowns.sizing': 'Dimensionamiento',
  'dropdowns.split-button': 'Botones Desplegables',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editores */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Estándar',
  'editors.quill-bubble': 'Quill Burbuja',

  /* 07.10.Formularios */
  'forms.basic': 'Básico',
  'forms.email': 'Email',
  'forms.email-muted': 'Nunca compartiremos tu email con nadie más.',
  'forms.password': 'Contraseña',
  'forms.submit': 'Enviar',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'Primero radio',
  'forms.second-radio': 'Segundo radio',
  'forms.third-radio-disabled': 'Tercera radio deshabilitada',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Registrarse',
  'forms.top-labels-over-line': 'Etiquetas Superiores Sobre la Línea',
  'forms.tags': 'Etiquetas',
  'forms.date': 'Fecha',
  'forms.state': 'Estado',
  'forms.top-labels-in-input': 'Etiquetas Superiores Sobre la Entrada',
  'forms.email-u': 'EMAIL',
  'forms.password-u': 'CONTRASEÑA',
  'forms.tags-u': 'ETIQUETAS',
  'forms.date-u': 'FECHA',
  'forms.state-u': 'ESTADO',
  'forms.grid': 'Cuadrícula de Formulario',
  'forms.address': 'Dirección',
  'forms.address2': 'Dirección 2',
  'forms.city': 'Ciudad',
  'forms.city-message': 'Por favor seleccione una ciudad!',
  'forms.state-message': 'Por favor seleccione un estado!',
  'forms.zip': 'Código Postal',
  'forms.signup': 'Regístrate',
  'forms.inline': 'Inline',
  'forms.validation': 'Validación',
  'forms.default': 'Defecto',
  'forms.firstname': 'Nombre de Pila',
  'forms.firstname-message': '¡Por favor, introduzca su nombre de pila!',
  'forms.lastname': 'Apellido',
  'forms.lastname-message': '¡Por favor ingrese su apellido!',

  /* 07.11.Componentes */
  'form-components.custom-inputs': 'Entrada Personalizada',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Estado Soltero',
  'form-components.state-multiple': 'Estado Múltiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Selector de Fechas',
  'form-components.date': 'Fecha',
  'form-components.date-range': 'Rango de Fechas',
  'form-components.date-with-time': 'Fecha con Hora',
  'form-components.embedded': 'Incrustado',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Soltar Archivos Aquí',
  'form-components.tags': 'Etiquetas',
  'form-components.switch': 'Cambiar',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverso',
  'form-components.secondary-inverse': 'Secondary Inverso',
  'form-components.slider': 'Deslizador',
  'form-components.double-slider': 'Doble Deslizador',
  'form-components.single-slider': 'Único Deslizador',
  'form-components.rating': 'Clasificación',
  'form-components.interactive': 'Interactivo',
  'form-components.readonly': 'Solo Lectura',
  'form-components.type-a-cake': 'Escribe un pastel',
  'form-components.start': 'Comienzo',
  'form-components.end': 'Fin',
  'form-components.tables': 'Tablas',
  /* 07.12.Iconos */
  'icons.simplelineicons': 'Simple Line Iconos',
  'icons.iconsmind': 'Iconsmind Iconos',

  /* 07.13.Grupos de Entrada */
  'input-groups.basic': 'Básico',
  'input-groups.sizing': 'Dimensionamiento',
  'input-groups.small': 'Pequeño',
  'input-groups.default': 'Defecto',
  'input-groups.large': 'Grande',
  'input-groups.checkboxes-and-radios': 'Checkboxes y radios',
  'input-groups.multiple-inputs': 'Entradas Múltiples',
  'input-groups.first-and-last-name': 'Nombre y apellido',
  'input-groups.multiple-addons': 'Complementos Múltiples',
  'input-groups.button-addons': 'Complementos Botón',
  'input-groups.button': 'Botón',
  'input-groups.buttons-with-dropdowns': 'Botones y Desplegables',
  'input-groups.dropdown': 'Desplegable',
  'input-groups.header': 'Encabezado',
  'input-groups.action': 'Accion',
  'input-groups.another-action': 'Otra accion',
  'input-groups.custom-select': 'Personalizada Select',
  'input-groups.options': 'Opciones',
  'input-groups.choose': 'Escoger...',
  'input-groups.custom-file-input': 'Entrada de Archivo Personalizada',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': '¡Hola Mundo!',
  'jumbotron.lead':
    'Esta es una unidad de héroe simple, un componente de estilo jumbotron simple para llamar la atención extra al contenido o información destacados.',
  'jumbotron.lead-detail':
    'Utiliza clases de utilidad para tipografía y espaciado para espaciar el contenido dentro del contenedor más grande.',
  'jumbotron.learn-more': 'Aprende más',

  /* 07.15.Modal */
  'modal.basic': 'Básico',
  'modal.modal-title': 'Título Modal',
  'modal.launch-demo-modal': 'Lanzar Demo Modal',
  'modal.scrolling-long-content': 'Contenido de Desplazamiento Largo',
  'modal.backdrop': 'Fondo',
  'modal.backdrop-value': 'Valor de Fondo',
  'modal.right-modal': 'Derecha Modal',
  'modal.launch-right-modal': 'Launch Derecha Modal',
  'modal.nested-modal': 'Modal Anidado',
  'modal.size': 'Tamaño',
  'modal.launch-large-modal': 'Lanzar Grande Modal',
  'modal.launch-small-modal': 'Lanzar Pequeño Modal',

  /* 07.16.Navegación */
  'nav.basic': 'Navegación Básico',
  'nav.active': 'Activo',
  'nav.disabled': 'Discapacitado',
  'nav.disabled-link': 'Enlace Discapacitado',
  'nav.link': 'Enlace',
  'nav.longer-link': 'Enlace de navegación más largo',
  'nav.another-link': 'Otro Enlace',
  'nav.right': 'Derecha',
  'nav.dropdown': 'Desplegable',
  'nav.header': 'Encabezado',
  'nav.action': 'Accion',
  'nav.another-action': 'Otra accion',
  'nav.horizontal-alignment': 'Alineación Horizontal',
  'nav.vertical-alignment': 'Alineación Vertical',
  'nav.pills': 'Navegación Píldoras',
  'nav.fill-justify': 'Navegación Llenar y Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Paginación Básico',
  'nav.pagination-sizing': 'Paginación Dimensionamiento',
  'nav.large': 'Grande',
  'nav.small': 'Pequeño',
  'nav.center': 'Centro',
  'nav.pagination-alignment': 'Alineación de Paginación',
  'nav.breadcrumb-basic': 'Migas de Pan Básico',

  /* 07.17.Tooltips y Popovers */
  'popover-tooltip.popover': 'Popovers',
  'popover-tooltip.tooltip': 'Tooltips',

  /* 07.18.Ordenable */
  'sortable.columns': 'Clasificar Columnas',
  'sortable.basic': 'Básico',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Tablas Bootstrap',
  'table.bootstrap-basic': 'Tablas Básicas',
  'table.bootstrap-striped': 'Cebreadas',
  'table.bootstrap-bordered': 'Tablas Con Bordes',
  'table.bootstrap-borderless': 'Tablas Sin Bordes',
  'table.bootstrap-hoverable': 'Tablas dinámicas',
  'table.bootstrap-responsive': 'Tablas Responsive',
  'table.react-tables': 'Tablas React',
  'table.react-pagination': 'Paginación',
  'table.react-scrollable': 'Tablas Con Voluta',
  'table.react-advanced': 'Filtro, Longitud y Salto',

  /* Property Info */
  "property-info.allcustomers": 'Todos los clientes"',
  'property-info.external-sources': 'Fuentes Externas',
  'property-info.faq': 'Preguntas Frecuentes',
  'property-info.documents': 'Documentos',
  'property-info.publish-ai': 'Publicar IA',
  'property-info.pre-built-templates': 'Plantillas Preconstruidas',
  'property-info.room-types': 'Tipos de Habitaciones',
  'property-info.about-property': 'Acerca de la propiedad',
  'property-info.about-properties': 'Acerca de las propiedades',
  'property-info.facilities-services': 'Instalaciones y servicios',
  'property-info.property-facilities': 'Instalaciones de la propiedad',
  'property-info.room-amenities': 'Servicios en la habitación',
  'property-info.property-contact': 'Contacto de la propiedad',
  'property-info.property-activities': 'Actividades de la propiedad',
  'property-info.property-location': 'Ubicación de la propiedad',
  'property-info.about-rooms': 'Acerca de las habitaciones',
  'property-info.about-sites': 'Acerca de los sitios',
  'property-info.special-emergencies': 'Emergencias',
  'property-info.gallery': 'Galería',
  'property-info.policies': 'Políticas',
  'property-info.nearby': 'Cercana',
  'property-info.transport': 'Transporte',
  'property-info.location': 'Localización',
  'property-info.about-rhproperty': 'Acerca de la casa de retiro',
  'property-info.related-topics': 'Temas relacionados',
  'property-info.assistant-options': 'Opciones de asistente',
  'property-info.restaurant-assistant-information':
    'Información del restaurante',
  'property-info.restaurant-assistant-options': 'Mensaje de bienvenida',
  'property-info.channel-messages': 'Mensajes de canal',
  'property-info.icon.gallery': 'Galería de iconos',
  'property-info.copilot': 'Copiloto',
  'property-info.sprint': 'pique',
  'property-info.home-information': 'Inicio Información',
  'property-info.loction': 'Ubicaciones',
  'property-info.rooms-and-images': 'Habitaciones e Imágenes',
  'property-info.trainig-data': 'Datos de entrenamiento',
  'property-info.flows': 'Flujos',
  'property-info.add-your-own': 'Añade tu propio',
  'property-info-utility-miscellaneous': 'Misceláneos',
  'property-info-utility-payment': 'Pagos',
  'property-info-utility-broadband': 'Banda ancha',
  'property-info-utility-emergency': 'Emergencia',
  'property-info-utility-mobile': 'Móvil',
  'property-info-utility-moving': 'Moviente',
  'property-info.publishMonitor': 'Publicar y monitorear',
  'property-info.webWidget': 'Widget web',
  'property-info.media': 'Medios',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Planes de tarifas',
  'rate-promo.rate-plan-addons': 'Complementos',
  'rate-promo.rate-plan-promos': 'Promociones',

  'title.property-information': 'Información de la propiedad',

  'property.message': 'Mensaje',
  'property.example': 'Ejemplo',
  'property.link': 'Enlaces',
  'property.image-carousel': 'Carrusel de imágenes',
  'property.Title': 'Título',
  'property.SubTitle': 'Subtítulo',

  'property.add-invoke-api': 'Invocar API',
  'property.add-message-button': 'Agregar mensajes',
  'property.add-img-button': 'Añadir imágenes',
  'property.add-link-button': 'Añadir enlace',
  'property.add-herocard-button': 'Agregar tarjeta de héroe',
  'property.add-api-button': 'Agregar botones',

  'menu.settings': 'Configuraciones',
  'menu.workflows': 'Flujos de trabajo',
  'menu.product_services': 'Productos y Servicios',
  'menu.product_recommander': 'Recomendador de Productos',
  'menu.digital_guide_book': 'Libro Guía Digital',
  'menu.welcome_message': 'Mensaje de Bienvenida',

  'menu.about-property': 'Acerca de la propiedad',
  'menu.property-facilities': 'Instalaciones de la propiedad',
  'menu.room-amenities': 'Servicios en la habitación',
  'menu.property-contact': 'Contacto de la propiedad',
  'menu.about-rooms': 'Acerca de las habitaciones',
  'menu.special-emergencies': 'Emergencias',
  'menu.ari': 'Disponibilidad y tarifas',
  'menu.conversations': 'Conversaciones',
  'menu.conversations.unified-inbox': 'Unificado Bandeja de entrada',
  'menu.conversations.active': 'Chats activos',
  'menu.conversations.archives': 'Archivo',
  'menu.conversations.missed-responses': 'Respuestas perdidas',
  'menu.conversations.ticket': 'Entradas',
  'menu.conversations.reply-templates': 'Plantillas de respuesta',
  'menu.bookings': 'Reservas',
  'menu.tickets': 'Leads y entradas',
  'menu.propinfo': 'Centro de conocimiento',
  'menu.rate-promos': 'Tarifas y promociones',
  'menu.finance': 'Finanzas',
  'menu.integration': 'Conectar',
  'menu.admin': 'Admin y seguridad',
  'menu.favourites': 'Favoritos',
  'menu.recommender': 'Flujo de conversación',
  'menu.assistant-setup': 'Configuración del asistente',
  'menu.show-filter': 'filtros',
  'menu.new': 'Nuevo',
  'menu.admin-insights': 'Información del administrador',
  'menu.super-admin': 'Gran administrador',
  'menu.groups': 'Grupos',
  'menu.properties': 'Propiedades',
  'menu.service-provider': 'Proveedores de servicios',
  'menu.spaces': 'Espacios',
  'menu.channel': 'Canales',
  'menu.application': 'Aplicaciones',
  'menu.content-manager': 'Gestor de Contenido',
  'menu.events-calendar': 'Calendario de Eventos',
  'menu.appearance-settings': 'Apariencia y Configuración',
  'menu.help': 'Ayuda',
  'menu.myAccounts': 'Mis cuentas',
  'menu.availability': 'Disponibilidad',
  'menu.guest-messaging': 'Mensajería de Huéspedes',
  'guest-messaging.settings': 'Configuración',
  'guest-messaging.outreach-setup': 'Configuración de Alcance',
  'guest-messaging.reservations': 'Reservas',
  'guest-messaging.insights_logs': 'Información y registros',
  'guest-messaging.placeholder': 'El módulo de Mensajería de Huéspedes llegará pronto.',
  'guest-messaging.reservation-source': 'Origen de datos de reservas',
  'guest-messaging.communication-channels': 'Canales de comunicación',
  'guest-messaging.templates': 'Plantillas',
  'guest-messaging.link': 'Enlace',
  'guest-messaging.business-profile': 'Perfil empresarial',

  'dashboards.send': 'Enviar',
  'dashboards.hello': 'Hola',
  'dashboards.notificationsAllowed': 'Notificaciones permitidas',
  'dashboards.allowNotifications': 'Permitir notificaciones',
  'dashboards.views': 'Vistas',
  'dashboards.bookingURL': 'URL de reserva',
  'dashboards.searchTags': 'Etiquetas de búsqueda',
  'dashboards.searchCategoryTags': 'Etiquetas de categoría de búsqueda',
  'dashboards.bedroom': 'Dormitorio',
  'dashboards.addBedroom': 'Añadir dormitorio',
  'dashboards.frequency': 'Frecuencia',
  'dashboards.includeSubpages': 'Incluir subpáginas',
  'dashboards.enableFaqs': 'Habilitar preguntas frecuentes',
  'dashboards.faqsDescription': 'Al habilitar preguntas frecuentes, puede ingresar preguntas mientras el sistema extrae respuestas correspondientes del contenido de la página web para crear preguntas frecuentes completas',
  'dashboards.faq': 'Preguntas frecuentes',
  'dashboards.deleteDocument': 'Eliminar documento',
  'dashboards.confirmDelete': '¿Está seguro de que desea eliminar?',
  'dashboards.addItem': 'Agregar elemento',
  'dashboards.addFirstWebPage': 'Agregar tu primera página web',


  'dashboards.tickets-by-category': 'Entradas por categoría',
  'dashboards.download': 'Descargar',
  'dashboards.space-booking': 'Reserva de espacio',
  'dashboards.gift-voucher': 'Vales regalo',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'De',
  'dashboards.to': 'A',
  'dashboards.active-groups': 'Grupos activos',
  'dashboards.active-properties': 'Propiedades activas',
  'dashboards.live-properties': 'Propiedades vivas',
  'dashboards.properties-going':
    'Propiedades en funcionamiento por rango de fechas',
  'dashboards.start-date': 'Fecha de inicio',
  'dashboards.end-date': 'Fecha de finalización',
  'dashboards.subscribe-to-reports': 'Suscríbete a los informes',
  'dashboards.previous-month': 'Mes anterior',
  'dashboards.yeartodate': 'El año hasta la fecha',
  'dashboards.lastyear': 'Panel de control del año pasado',
  'dashboards.last-7-days': 'Los últimos 7 días',
  'dashboards.last-30-days': 'Últimos 30 días',
  'dashboards.last-60-days': 'Últimos 60 días',
  'dashboards.last-90-days': 'Últimos 90 días',
  'dashboards.digital-assistant-engagement': 'Compromiso del asistente digital',
  'dashboards.total-overnight-conversations':
    'Conversaciones totales y nocturnas (de 7 p. m. a 7 a. m.)',

  'dashboards.popular-compendium': 'Elementos populares del menú del compendio',
  'dashboards.wordcloudofcompendium': 'Nube de palabras del elemento del menú del compendio',
  'dashboards.wordcloudonthings': 'Nube de palabras sobre preguntas de los visitantes del sitio web y elementos del menú  ',
  'dashboards.common-asked': 'Preguntas frecuentes y platos populares del menú',

  'dashboards.website-visitor-asking':
    'Cosas sobre las que preguntan los visitantes del sitio web',
  'dashboards.visit-country': 'Visita al sitio web por país',
  'dashboards.visit-traffic': 'País del tráfico del sitio web',
  'dashboards.rooms-product': 'Habitaciones y Productos',
  'dashboards.popular-room-product': 'Habitaciones y productos populares',

  'dashboards.messenger-stats': 'Elementos populares del menú',
  'dashboards.messenger-stats-topic-view':
    'Estadísticas sobre vistas de elementos del menú',
  'dashboards.messenger-stats-visits': 'Vistas de elementos de menú',
  'dashboards.opening-menu-items':
    'Número de visitantes del sitio web que abren elementos del menú',

  'dashboards.number-totalavatarclick': 'Clics de avatar totales',

  'dashboards.clicks': 'Clics',
  'dashboards.leads': 'Dirige',
  'dashboards.hours': 'Horas',
  'dashboards.minutes': 'Minutos',

  'dashboards.ai-chatbot': 'Chatbot de IA',
  'dashboards.compendium': 'Compendio',
  'dashboards.compendium-digital-usage': 'Uso del compendio digital',
  'dashboards.compendium-unique-visits': 'Escaneos/clics de códigos QR',
  'dashboards.compendium-opening-menu-items':
    'Número de elementos del menú vistos',
  'dashboards.compendium-total-digital-clicks':
    'Total de visualizaciones de elementos del menú',
  'dashboards.compendium-total-qr-code': 'Total de escaneos/clics de códigos QR',
  'dashboards.compendium-avg-menu-items': 'Promedio de visualizaciones de elementos de menú por escaneo',


  'property.delete': 'Borrar',
  'menu.dashboards': 'Perspectivas',
  'menu.userroles': 'Usuarios y roles',
  'menu.members': 'Miembros',
  'menu.guest-pass': 'Pase de invitado',
  'menu.ratebookings': 'Tarifas y reservas',
  'dashboards.engagement-time': 'Tiempo de participación del asistente digital',
  'dashboards.conversations-minutes':
    'Minutos totales y minutos de conversaciones durante la noche (de 7:00 p. m. a 7:00 a. m.)',
  'dashboards.visitor-questions': 'Preguntas de los visitantes',
  'dashboards.recent-queries': 'Consultas recientes',
  'dashboards.visitor-saying':
    'Lo que sus visitantes le dicen al Asistente digital',
  'dashboards.contacts-prechatform-leavemessage':
    'Contactos almacenados desde el formulario previo al chat y dejar mensaje',
  'dashboards.percentage-accuracy': 'Comprensión de la precisión',
  'dashboards.percentage-conversion':
    'Conversión de tráfico del sitio web a chat',
  'dashboards.percentage-avatarclick':
    'Tráfico del sitio web a clics de Avatar',
  'dashboards.percentage-negativefeedback':
    'Comentarios negativos como porcentaje de clics de Avatar',
  'dashboards.percentage-amenties': 'Consultas de servicios',
  'dashboards.percentage-booking': 'Consultas de reserva',
  'dashboards.percentage-webchats': 'Chats en el sitio web',
  'dashboards.percentage-facebookchat': 'Chats de Facebook',
  // 'dashboards.number-webchattime': 'Tiempo total de chat web',
  'dashboards.number-webchattime': 'Tiempo total de conversación',
  'dashboards.number-totalconversation': 'Conversaciones Total',
  'dashboards.number-averagetimeconversation':
    'Tiempo Promedio Por Conversación',
  'dashboards.number-websiteconversation': 'Conversaciones del sitio web',
  'dashboards.number-facebookconversation': 'Conversaciones de Facebook',
  'dashboards.number-estimatedtimesaving': 'Ahorro de tiempo estimado',
  'dashboards.number-googlemapsconversation': 'Conversaciones de Google Maps',
  'dashboards.number-whatsappconversation': 'Conversaciones de WhatsApp',
  'dashboards.number-instagramconversation': 'Conversaciones de Instagram',
  'dashboards.number-agentconversation': 'Conversaciones de agentes',
  'dashboards.number-amenityqueries': 'Consultas de servicios',
  'dashboards.number-bookingenquiries': 'Consultas de reserva',
  'dashboards.number-groupbookingenquiries': 'Consultas de reserva de grupo',
  'dashboards.number-eventenquiries': 'Consultas de eventos',
  'dashboards.number-longstayenquiries': 'Consultas de Larga Estancia',
  'dashboards.number-totaltickets': 'Entradas',
  'dashboards.number-returncustomer': 'Cliente de devolución',
  'dashboards.number-redirects': 'Sitio web Redirecciones',
  'dashboards.number-bookingengineleads':
    'Clientes potenciales del motor de reservas',
  'dashboards.number-roomnightsreferred': 'Noches de habitación recomendadas',
  'dashboards.number-revenuereferred': 'Ingresos referidos',
  'dashboards.welcomeMessage': 'Mensaje de bienvenida',
  'dashboards.personalizeGreeting': 'Personaliza la forma en que se saluda a los clientes para reflejar tu marca, estilo y etiqueta, asegurando que reciban la bienvenida más cálida. Personaliza los saludos para reflejar tu marca y crear una acogida cálida.',
  'dashboards.addRoomDetails': 'Agrega detalles de cada una de tus habitaciones para que los huéspedes puedan descubrir fácilmente todo lo que necesitan para elegir la opción perfecta y hacer que el proceso de reserva sea más simple y rápido.',
  'dashboards.trainAIFAQs': 'Entrena la IA con preguntas frecuentes',
  'dashboards.manualQuestions': 'Algunas preguntas no pueden responderse con documentos ni encontrarse en el sitio web. Aquí puedes agregar preguntas manualmente para asegurarte de que los clientes siempre tengan la información que necesitan al alcance de la mano.',
  'dashboards.publishAI': 'Publica la IA para reflejar las actualizaciones más recientes',
  'dashboards.retrainAfterChanges': 'Cuando realices cambios en el Knowledge Hub o en los formularios, asegúrate de volver a entrenar el chatbot con la información actualizada. Publicar tu IA garantiza que el chatbot proporcione las respuestas más precisas y actualizadas.',
  'dashboards.enhanceKnowledge': 'Mejora el conocimiento de la IA rastreando las consultas sin respuesta',
  'dashboards.reviewUnanswered': 'Siempre que la IA no pueda responder una pregunta o proporcione solo detalles limitados, encontrarás esas consultas aquí. Revísalas para identificar lagunas en tu Knowledge Hub o preguntas únicas de los huéspedes.',
  'dashboards.manageMedia': 'Gestionar medios',
  'dashboards.mediaGallery': 'Siempre que cargues imágenes como habitaciones, amenidades, logotipos o tu avatar digital, aparecerán en esta galería, brindándote un lugar central para gestionar elementos visuales y asegurarte de que tus huéspedes vean lo que hace que tu negocio sea único.',
  'dashboards.createForms': 'Crea formularios fácilmente y recibe notificaciones con cada envío.',
  'dashboards.manageForms': 'Crea y administra formularios para recopilar información del cliente, configurar notificaciones y personalizarlos para diferentes idiomas.',
  'dashboards.personalizeResponse': 'Personaliza el estilo de respuesta y cómo progresa la conversación',
  'dashboards.controlConversation': 'Esta función avanzada te da la capacidad de moldear y controlar cómo se desarrollan las conversaciones con tus clientes a través de diferentes canales.',

  'menu.bookingsmenu': 'Reservas',
  'menu.guests': 'Información del huésped',
  'menu.whatsnew': 'Qué hay de nuevo',

  'menu.formbuilder': 'Creador de formularios',
  'forms.forms-title': 'Forma',
  "dashboards.trainAI": "Entrena la IA con documentos",
  "dashboards.uploadDocuments": "Sube documentos para ayudar a tu IA a conocer tu negocio y asistir a los clientes como lo harías tú. Puedes añadir archivos en formato .doc, .pdf o .txt.",
  'menu.virtualfrontdesk': 'Recepción virtual',
  'menu.guestservice': 'Servicios de invitado',
  'virtual-front.common-questions': 'Preguntas comunes',
  'virtual-front.add-on-upsells': 'Complementos & ventas adicionales',
  'virtual-front.service-order': 'Orden de servicio',
  //'virtual-front.guest-service-add-on-upsells': "Servicios para huéspedes y complementos",
  'virtual-front.guest-service-add-on-upsells': 'Libro de visitas digital',
  'virtual-front.outbound': 'Saliente',
  'virtual-messenger': 'Mensajera',

  'missed-response.missed-response-title': 'Título de respuesta perdida',

  //unified inbox 'content 
  'content.allconversation': 'Todas las conversaciones',
  'content.active': 'Activas',
  'content.tickets': 'Tickets',
  'content.filter': 'Filtrar',
  'content.createtickets': 'Crear tickets',
  'content.conversation': 'Conversación',
  'content.knowledgesearch': 'Búsqueda de conocimiento',
  'content.reply': 'Responder',
  'content.visitorinfo': 'Información del visitante',
  'content.callinfo': 'Información de la llamada',
  'content.allinsights': 'Todas las ideas',
  'content.availabilityrates': 'Disponibilidad y tarifas',
  'content.callback': 'Devolver llamada',
  'content.close': 'Cerrar',
  'content.sms': 'SMS',
  'content.timestamp': 'Marca de tiempo',
  'content.topics': 'Temas',
  'content.callingparty': 'Parte que llama',
  'content.accountdomain': 'Dominio de cuenta',
  'content.calledparty': 'Parte llamada',
  'content.recording': 'Grabación',
  'content.phonesystemoriginationcallid': 'ID de llamada de origen del sistema telefónico',
  'content.phonesystemterminationcallid': 'ID de llamada de terminación del sistema telefónico',
  'content.uniqueconversationid': 'ID de conversación única',
  'content.regenerateinsights': 'Regenerar ideas',
  'content.customersentiment': 'Sentimiento del cliente',
  'content.neutral': 'Neutral',
  'content.conversationinsights': 'Ideas de conversación',
  'content.broadbandoutage': 'Interrupción de banda ancha',
  'content.customeridverification': 'Verificación de ID del cliente',
  'content.serviceactivationdate': 'Fecha de activación del servicio',
  'content.followups': 'Seguimientos',
  'content.actionneeded': 'Se requiere acción',
  'content.uniqueConversationId': 'ID de conversación única',
  'content.uniqueChatId': 'ID de chat única',
  'content.recording&transcript': 'Grabación y transcripción',
  'content.chatinsights': 'Información del chat',
  'content.visitedpages': 'Páginas visitadas',
  'content.deviceinfo': 'Información del dispositivo',
  'content.chatstartedonthispage': 'El chat comenzó en esta página',
  'content.prechatinfo': 'Información previa al chat',
  'content.notes': 'Notas',
  'content.reassign': 'Reasignar',
  'content.open': 'Abierto',
  "content.dismiss": "Cerrar",
  "content.add_placeholder": "Agregar valores de marcador de posición",
  "content.mobile_number": "Número de móvil",
  "content.please_select": "Por favor seleccione",
  'content.sendwhatsapp': 'Enviar mensaje de WhatsApp',

  /* Missed Response */
  'feedback.missed-question': 'Pregunta no respondida',
  'feedback.conversation-summary': 'Resumen de la conversación',
  'feedback.dates-in-spanish': 'Las fechas deben estar en español',
  'feedback.resolve': 'Resolver',
  'feedback.ignore': 'Ignorar',

  // Integration
  'integration.select_properties': 'Seleccionar propiedades',
  'integration.select_properties_enabled': 'Seleccionar las propiedades habilitadas mediante esta integración',
  'integration.services_addons': 'Seleccionar servicios y complementos',
  'integration.services_visible': 'Seleccionar qué servicios y complementos serán visibles en esta página',
  'integration.appearance': 'Apariencia',
  'integration.appearance_customize': 'Elige el nombre de tu asistente digital, avatar y configura tus colores',
  'integration.booking_calendar': 'Calendario de reservas',
  'integration.booking_calendar_style': 'Elige el estilo del pop‑up del calendario de reservas',
  'integration.nudges': 'Sugerencias',
  'integration.nudges_setup': 'Configura mensajes proactivos para involucrar a los visitantes del sitio web',
  'integration.position': 'Posición',
  'integration.position_control': 'Controla la posición del widget de chat en tu sitio web',
  'integration.custom_fonts': 'Fuentes personalizadas',
  'integration.custom_fonts_upload': 'Sube cualquier fuente personalizada que quieras usar en la página',
  'integration.custom_css': 'CSS personalizado',
  'integration.custom_css_usage': 'Usa CSS para personalizar tu Compendio Digital',
  'integration.location': 'Ubicación',
  'integration.location_embed': 'Agrega la URL de incrustación de tu ubicación',
  'integration.external_links': 'Enlaces externos',
  'integration.external_links_add': 'Agrega tus enlaces',
  'integration.language': 'Idioma',
  'integration.widget_languages': 'Selecciona los idiomas para el widget de chat',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Activa tu asistente digital',
  'integration.chatbot_security': 'Mantén tu Messenger seguro',
  'integration.chatbot_trusted_pages': 'Lista tus páginas confiables para mostrar el Chatbot',
  'integration.chatbot_publish': 'Publica tu asistente digital',
  'integration.chatbot_install': 'Copia el fragmento de código para instalar tu asistente digital',


};
export default esMessages;